// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2L040","inputWrap":"CustomTip_inputWrap__NbOV4"};